const genesysCloudStoreNameSpace = 'Genesys Cloud';

export const withGenesysCloudStoreNameSpace = (group: string) => (actionType: string) => `[${genesysCloudStoreNameSpace}][${group}] ${actionType}`;
